var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"flex-shrink":"0"}},[_c('img',{attrs:{"src":_vm.componente.value.imageUrl,"alt":"Image"},on:{"load":function($event){return _vm.$emit('loaded')}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }